var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsanaLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 97 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.733 47.358c-11.626 0-21.049 9.423-21.049 21.047 0 11.626 9.423 21.05 21.049 21.05 11.624 0 21.047-9.424 21.047-21.05 0-11.624-9.423-21.047-21.047-21.047zm-54.685.001C9.424 47.36 0 56.781 0 68.406 0 80.03 9.424 89.454 21.048 89.454c11.625 0 21.049-9.423 21.049-21.048 0-11.625-9.424-21.047-21.05-21.047zm48.39-26.312c0 11.625-9.423 21.05-21.047 21.05-11.626 0-21.049-9.425-21.049-21.05C27.342 9.425 36.765 0 48.391 0c11.624 0 21.046 9.424 21.046 21.047z",
    fill: "url(#asana-logo_svg__a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "asana-logo_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(64.1297 0 0 59.2754 48.39 48.889)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F95D8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#F95353"
  })))));
}
export default SvgAsanaLogo;